import { API } from "./api";

export function track(event, meta = {}) {
  try {
    const payload = JSON.stringify({ event, ...meta, path: window.location.pathname });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/analytics/event`, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(`${API}/analytics/event`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true });
    }
  } catch (e) { /* analytics must never break UX */ }
}

export async function buildBookingLink({ checkin, checkout, guests }) {
  const params = new URLSearchParams();
  if (checkin) params.set("checkin", checkin);
  if (checkout) params.set("checkout", checkout);
  if (guests) params.set("guests", guests);
  const res = await fetch(`${API}/booking/link?${params.toString()}`);
  return res.json();
}

export function whatsappLink(number, message) {
  const n = (number || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${n}?text=${encodeURIComponent(message)}`;
}
